import { RootState } from '@store/store'
import { jobAdapterExport } from '@editor/store/slices/job.slice'
import { createSelector } from '@reduxjs/toolkit'

export const { selectAll: selectAllJobs, selectById: selectJobById } =
  jobAdapterExport.getSelectors<RootState>((state: RootState) => state.jobs)

export const getJobErrors = (state: RootState) => state.jobs.error
export const getJobLoading = (state: RootState) => state.jobs.loading

export const isJobInProgress = (state: RootState) => {
  return (id: string) => state.jobs.inProgress.includes(id)
}
